import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { PrimaryButton } from 'shared/components/button'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

type PrimaryButtonProps = ComponentProps<typeof PrimaryButton>

export const PrimaryButtonWithCustomTheme = ({ className, ...restProps }: PrimaryButtonProps) => (
  <PrimaryButton
    className={twMerge(
      '!bg-THEME-secondary !text-THEME-block-background hover:!bg-THEME-hover-secondary hover:!text-THEME-block-background disabled:!border-THEME-disabled disabled:!bg-THEME-disabled',
      addPublicCustomClassNamePrefix(['course__button', 'course__button--primary']),
      className,
    )}
    {...restProps}
  />
)
